<button mat-icon-button class="chat-button" color="primary" (click)="toggle()">
  <mat-icon>chat</mat-icon>
</button>

<ng-container *ngIf="visible">
  <hivegpt-chat-drawer
  [apiKey]="apiKey"
  [bgBubbleAi]="bgBubbleAi"
  [bgBubbleUser]="bgBubbleUser"
  [bgGradient]="bgGradient"
  [botName]="botName"
  [closeButtonbgColor]="closeButtonbgColor"
  [closeButtonColor]="closeButtonColor"
  [credentials]="credentials"
  [dateTextColor]="dateTextColor"
  [dateTimeColor]="dateTimeColor"
  [eventId]="eventId"
  [eventName]="eventName"
  [formFieldBgColor]="formFieldBgColor"
  [formFieldTextColor]="formFieldTextColor"
  [fullView]="fullView"
  [greeting]="greeting"
  [gradientColors]="gradientColors"
  [messageTextColorAi]="messageTextColorAi"
  [messageTextColorUser]="messageTextColorUser"
  [sendButtonColor]="sendButtonColor"
  [sendButtonTextColor]="sendButtonTextColor"
  [showClose]="showClose"
  [thumbsDownMessages]="thumbsDownMessages"
  [thumbsUpMessage]="thumbsUpMessage"
  [unknownResponses]="unknownResponses"
  [useOpenAi]="useOpenAi"
  [userId]="userId"
  [botId]="botId"
  >
  </hivegpt-chat-drawer>
</ng-container>
